import { Protocol } from '../../types/sharedTypeImpl.ts';
import { Change } from './change.ts';
import { getFieldChange } from './getChange.ts';
import { getMachineChange } from './getMachineChange.ts';
import { getProgramsChanges } from './getProgramsChanges.ts';


export function getMetadataChanges(
    protocolNew: Protocol,
    protocolOld: Protocol,
    machineNames: ReadonlyMap<string, string> = new Map(),
): Change[] {
    const changes: (Change | null)[] = [];

    changes.push(getFieldChange(protocolNew, protocolOld, 'partName', ['Part number']));
    changes.push(getFieldChange(protocolNew, protocolOld, 'partRevision', ['Revision']));
    changes.push(...getProgramsChanges(protocolOld, protocolNew));
    changes.push(getFieldChange(protocolNew, protocolOld, 'generalTolerance', ['General tolerance']));
    changes.push(getFieldChange(protocolNew, protocolOld, 'customer', ['Customer']));
    changes.push(getFieldChange(protocolNew, protocolOld, 'comment', ['Comment']));
    changes.push(getMachineChange(
        protocolNew.allowedMachines ?? [],
        protocolOld.allowedMachines ?? [],
        machineNames,
    ));
    changes.push(getFieldChange(protocolNew, protocolOld, 'measureInterval', ['Measurement interval']));

    return changes.filter((change) => change !== null) as Change[];
}
